import React from "react";

export const QUESTIONS = [
    {
        category: "notification",
        content: <>
            <h1>
                Velkommen til Mekle
            </h1>
            <p>
                Svar på noen spørsmål om kravet som er bestridt, så vil vi håndtere saken videre.
            </p>
        </>,
    },
    {
        pkey: "business_name",
        label: "Hva er navnet på virksomheten du representerer?",
        description: "Fyll inn navnet på virksomheten som du svarer på spørsmål på vegne av.",
        type: "string",
        placeholder: "Tast navnet her",
    },
    {
        isSubQuestion: true,
        pkey: "contact_name",
        label: "Navnet ditt",
        type: "string",
        placeholder: "Ola Nordmann",
    },
    {
        isSubQuestion: true,
        pkey: "contact_email",
        label: "Eposten din",
        placeholder: "ola@nordmann.as",
        type: "string",
    },
    {
        isSubQuestion: true,
        pkey: "contact_phone",
        label: "Telefonnummeret ditt",
        placeholder: "99 99 99 99",
        type: "string",
    },
    {
        pkey: "sum",
        label: "Hva er hovedstolen/kravet (summen) på faktura eller krav som er bestridt?",
        type: "string",
        placeholder: "Tast summen her",
    },
    {
        pkey: "reason",
        label: "Hva er motpartens sin begrunnelse for at kravet er bestridt?",
        description: "Som regel har debitor en begrunnelse for hvorfor kravet ikke er betalt. Dette kan for eksempel være uenighet om hva som ble avtalt, manglende kvalitet i leveransen, feil og mangler etc.",
        type: "text",
        placeholder: "Beskriv begrunnelsen her",
    },
    {
        label: "Har du kontaktinfo til motpart (debitor)?",
        description: "Vi vil ikke ta kontakt med motpart før vi har hatt dialog og avklart med deg.",
        pkey: "has_contact_info",
        type: "boolean",
        triggerOnSelect: true,
        options: [
            {
                label: "Ja",
                value: true,
            },
            {
                label: "Nei",
                value: false,
            },
        ],
    },
    {
        isSubQuestion: true,
        belongsTo: "has_contact_info",
        pkey: "part_name",
        label: "Navn på motpart",
        type: "string",
        placeholder: "Ola Nordmann AS",
    },
    {
        isSubQuestion: true,
        belongsTo: "has_contact_info",
        pkey: "part_email",
        label: "Epost til motpart",
        placeholder: "ola@nordmann.as",
        type: "string",
    },
    {
        isSubQuestion: true,
        belongsTo: "has_contact_info",
        pkey: "part_phone",
        label: "Telefon til motpart",
        placeholder: "99 99 99 99",
        type: "string",
    },
    {
        pkey: "where_did_you_find_us",
        label: "Hvordan hørte du om oss?",
        type: "dropdown",
        options: [
            {
                label: "Velg fra listen",
            },
            {
                label: "Axactor",
                id: "Axactor",
            },
            {
                label: "Azets",
                id: "Azets",
            },
            {
                label: "Kravia",
                id: "Kravia",
            },
            {
                label: "Ikke på listen",
                id: "Ikke på listen",
            },
        ],
    },
];
